import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  es: {
    translation: {
      common: {
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        cancel: 'Cancelar',
        save: 'Guardar',
        delete: 'Eliminar',
        edit: 'Editar',
        create: 'Crear',
        search: 'Buscar',
        filter: 'Filtrar',
        actions: 'Acciones',
        name: 'Nombre',
        email: 'Email',
        status: 'Estado',
        active: 'Activo',
        inactive: 'Inactivo',
        yes: 'Sí',
        no: 'No',
      },
      auth: {
        login: 'Iniciar Sesión',
        logout: 'Cerrar Sesión',
        signup: 'Registrarse',
        forgotPassword: 'Olvidé mi contraseña',
        password: 'Contraseña',
        confirmPassword: 'Confirmar Contraseña',
        rememberMe: 'Recordarme',
        loginTitle: 'Inicia sesión en tu cuenta',
        signupTitle: 'Crea tu cuenta',
        tenantSlug: 'Código de empresa',
        enterTenantSlug: 'Ingresa el código de tu empresa',
        continue: 'Continuar',
      },
      app: {
        dashboard: 'Dashboard',
        users: 'Usuarios',
        company: 'Empresa',
        audit: 'Auditoría',
        profile: 'Perfil',
        settings: 'Configuración',
        welcome: 'Bienvenido',
        userManagement: 'Gestión de Usuarios',
        companySettings: 'Configuración de Empresa',
        auditLogs: 'Registros de Auditoría',
        createUser: 'Crear Usuario',
        editUser: 'Editar Usuario',
        fullName: 'Nombre Completo',
        username: 'Usuario',
        role: 'Rol',
        emailVerified: 'Email Verificado',
        createdAt: 'Fecha de Creación',
        legalName: 'Razón Social',
        rfc: 'RFC',
        website: 'Sitio Web',
        logo: 'Logo',
        uploadLogo: 'Subir Logo',
        action: 'Acción',
        timestamp: 'Fecha y Hora',
        details: 'Detalles',
        user: 'Usuario',
        systemInformation: 'Información del Sistema',
        systemInformationDescription: 'Estado actual del sistema y configuración',
        tenantId: 'ID de Empresa',
        created: 'Creado',
        totalUsers: 'Total de Usuarios',
        activeUsers: 'usuarios activos',
      }
    }
  },
  en: {
    translation: {
      common: {
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        actions: 'Actions',
        name: 'Name',
        email: 'Email',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive',
        yes: 'Yes',
        no: 'No',
      },
      auth: {
        login: 'Sign In',
        logout: 'Sign Out',
        signup: 'Sign Up',
        forgotPassword: 'Forgot Password',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        rememberMe: 'Remember Me',
        loginTitle: 'Sign in to your account',
        signupTitle: 'Create your account',
        tenantSlug: 'Company Code',
        enterTenantSlug: 'Enter your company code',
        continue: 'Continue',
      },
      app: {
        dashboard: 'Dashboard',
        users: 'Users',
        company: 'Company',
        audit: 'Audit',
        profile: 'Profile',
        settings: 'Settings',
        welcome: 'Welcome',
        userManagement: 'User Management',
        companySettings: 'Company Settings',
        auditLogs: 'Audit Logs',
        createUser: 'Create User',
        editUser: 'Edit User',
        fullName: 'Full Name',
        username: 'Username',
        role: 'Role',
        emailVerified: 'Email Verified',
        createdAt: 'Created At',
        legalName: 'Legal Name',
        rfc: 'Tax ID',
        website: 'Website',
        logo: 'Logo',
        uploadLogo: 'Upload Logo',
        action: 'Action',
        timestamp: 'Timestamp',
        details: 'Details',
        user: 'User',
        systemInformation: 'System Information',
        systemInformationDescription: 'Current system status and configuration',
        tenantId: 'Tenant ID',
        created: 'Created',
        totalUsers: 'Total Users',
        activeUsers: 'active users',
      }
    }
  }
};

// Force Spanish immediately 
i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    lng: 'es', // Force Spanish as default language
    debug: true, // Enable debug to see what's happening
    
    interpolation: {
      escapeValue: false,
    },

    // Ensure synchronous loading
    initImmediate: false,
  });

export default i18n;